import styled from 'styled-components';
import img from "../../assets/images/bannerSecondBg.png";
import bulletIcon from "../../assets/images/bulletIcon.svg";
// import rewardsBanner from "../../assets/images/rewardsBanner.png";

export const Wrapper = styled.div`
	 background:  transparent radial-gradient(closest-side at 55% 100%, #FF9F5D 0%, #D54D14 100%) no-repeat padding-box;
	border-radius: 20px;
	margin-top: 20px;
	

&.banner{

	background-repeat: no-repeat;
	 background-size:100%; 
	background-position: right;
	background-size: auto;
	

margin-bottom: 80px;
& > div{
	background:url(${img});
	background-repeat: no-repeat;
	 background-size: contain; 
	background-position: 40px bottom;
	background-size: auto;
	height: 528px;
	
	.left {
		border-radius: 20px;
		max-width: 811px;
		padding-left: 101px;
		img{
			min-width: 20px;
			height: 100%;
		
			
		}
		/* max-width: 530px; */
		h2 {
			text-align: left;
			font-family: "Noto Sans", sans-serif;
			font-size: 50px;
			font-weight: 700;
			letter-spacing: 0px;
			line-height: 56px;
			color: #fff;
			opacity: 1;
			margin-bottom: 12px;
		}
		
		p {
			text-align: left;
		  font-size: 20px;
		  line-height: 30px;
			letter-spacing: 0px;
			color: #fff;
			margin-bottom: 18px;
			max-width: 638px;
			font-style: italic;
			
		}
	}
	/* .right{
		position: relative;
		
		margin-top: -34px;
	} */
}
}



/* &.paymentSection{
		&>div{
			min-height: 460px;
			padding: 0 40px;
		.right{
			
			flex: 0 1 551px;
			background-repeat: no-repeat;
			background-position: left bottom;
			background-size: contain;
		align-self: stretch;
		&>div{
			justify-content: end;
    height: 100%;
    align-items: end;
	&> .qr{
		transform: translateY(-76px) translateX(22px)
	}
		}
		}
		}
		.left {
	max-width: 590px;
	flex: 0 1 590px;

	
	
		h1 {
			text-align: left;
			font: normal normal 900 40px/45px ;
			letter-spacing: 0px;
			color: #000000;
			opacity: 1;
			margin-bottom: 12px;
		}
		ul {
			list-style: 'none';
			margin-bottom: 32px;
		}
		li {
			margin-bottom: 10px;
			img{
				flex-shrink: 0;
				width: 20px;
    height: 20px;
			}
		}

		li:last-child {
			margin-bottom: 0;
		}
		button {
			background: #ffffff 0% 0% no-repeat padding-box;
			border: 1px solid #00baf2;
			background: #ffffff 0% 0% no-repeat padding-box;
			border-radius: 8px;
			opacity: 1;
			color: #00baf2;
			padding-left: 30px;
			padding-right: 30px;
		}
		.img_app {
			height: 50px;
		}
	}
	
	.right_data {
		
		background-color: #F6FDF3;
		max-width: 530px;
		border-radius: 20px;
		opacity: 1;
		min-height: 465px;
		h2 {
			text-align: left;
			font: normal normal 900 60px/60px ;
			letter-spacing: 0px;
			color: #000000;
			opacity: 1;
			margin-bottom: 12px;
		}
		p {
			text-align: left;
			font: normal normal normal 20px/30px ;
			letter-spacing: 0px;
			color: #000000;
			margin-bottom: 42px;
		}
		h1 {
			text-align: left;
			font: normal normal 900 40px/45px ;
			letter-spacing: 0px;
			color: #000000;
			opacity: 1;
			margin-bottom: 12px;
		}
		ul {
			list-style: 'none';
			margin-bottom: 32px;
		}
		li {
			margin-bottom: 10px;
		}

		li:last-child {
			margin-bottom: 0;
		}
		button {
			background: #ffffff 0% 0% no-repeat padding-box;
			border: 1px solid #00baf2;
			background: #ffffff 0% 0% no-repeat padding-box;
			border-radius: 8px;
			opacity: 1;
			color: #00baf2;
			padding-left: 30px;
			padding-right: 30px;
		}
		.img_app {
			height: 50px;
		}
	}
	} */

	@media only screen and (max-width: 1200px) {
		&.banner{
			&>div{
				.left{
					align-self: flex-start!important;
					margin-top: 80px;
					padding-left: 64px;
				}
			}
		
		}
	}
	@media only screen and (max-width: 992px) {
		&.banner{
			&>div{
				.left{
					align-self: flex-start!important;
					margin-top: 80px;
					padding-left: 64px;
					&>p{
						margin-bottom: 0px;
						margin-top: 10px;
					}
				}
			}
		
		}
	
		/* &.paymentSection{
			padding: 30px 30px 0;
			&>div{
				flex-direction: column;
				gap: 0;
				padding-top:40px;
				.left{
					flex: 0 0 100%;
				}
				.right{
					flex: 0 0 500px;
					&>div > .qr {
						    transform: translateY(-76px) translateX(0);
					}
				}
			}
		} */
	}

	

	@media only screen and (max-width: 767px) {
		background:  transparent radial-gradient(closest-side at 55% 100%, #FF9F5D 0%, #D54D14 100%) no-repeat padding-box;
	border-radius: 20px;
	margin-top: 20px;
		&.banner{
			&>div{
				/* min-height: 300px; */
				height: 100%;
				.left{
					align-self: flex-start!important;
					margin-top: 40px;
					padding-left: 20px;
					.heading-2{
						font-size: 30px;
						line-height: 30px;
					}
					&>p{
					font-size: 16px;
					margin-top: 20px;
					margin-bottom: 20px;
					}
					li{
						font-size: 16px;
					}
				}
				.right{
					display: none;
				}
			}
		
		}

	
		.left .img_app {
			height: 100%;
		}
		.left button {
			padding: 15px;
		}
	}
	@media only screen and (max-width: 520px) {
		&.banner{
			&>div{
				.left{
					align-self: flex-start!important;
					margin-top: 0;
					padding-left: 20px;
					.heading-2{
						font-size: 20px;
						margin-top:0px;
					}
					&>p{
					font-size: 12px;
					line-height: 15px
					}
					li{
						font-size: 12px;
					}
				}
			}
		
		}
	padding: 20px;
		&> div{
			min-height: auto;
		
		}
		.heading-2 {
			line-height:20px;
			margin-top: 14px;
		}
		.left{
			width:100%;
			line-height: 20px;
			min-height: auto;
		}
		.app{
			h3{
				font-size: 12px;
			}
			img{
				width:"100px"
			}
		}
		.right_data{
			min-height: auto;
			padding-bottom: 20px;
			background-color: #F6FDF3;
			margin-inline: -20px!important;
			padding-inline: 20px!important;
		}
	}
`;


 export const ListWrapper = styled.ul`
 padding-left: 20px;
 li{
	color: ${(props) => (props.color ? props.color : '#fff')};
	font-size: 20px;
	line-height: 30px;
	list-style-image: url(${bulletIcon});
 }
`;